import styled from "@emotion/styled";
import { default as FilledCircledXRaw } from "/public/assets/filled-circled-x.svg?react";

export const FilledCircledX = styled(FilledCircledXRaw)`
  color: var(--tw-rose-500);
`;
